import { render, staticRenderFns } from "./BotOrdersModal.vue?vue&type=template&id=11e4df93&scoped=true"
import script from "./BotOrdersModal.vue?vue&type=script&lang=js"
export * from "./BotOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./BotOrdersModal.vue?vue&type=style&index=0&id=11e4df93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e4df93",
  null
  
)

export default component.exports